<template>
    <v-menu ref="menu" v-model="docCreatedDateRangeMenu" :close-on-content-click="false"
        :return-value.sync="docCreatedDateRange" transition="slide-y-transition" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
            <!-- prepend-inner-icon="mdi-calendar" -->
            <v-text-field v-model="docCreatedDateRangeText" :label="label" dense hide-details outlined v-bind="attrs"
                v-on="on" :append-icon="docCreatedDateRangeText ? 'mdi-close' : ''
                    " @click:append="clearDateFilter" placeholder="e.g 01 Jan - 30 Jan">
            </v-text-field>
        </template>
        <v-date-picker v-model="docCreatedDateRange" no-title scrollable range>
            <v-btn text @click="clearDateFilter"> Clear </v-btn>
            <v-btn text @click="docCreatedDateRangeMenu = false">
                Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="doDateFilter">
                OK
            </v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>
import moment from 'moment';

export default {
    name: "DatePickerTextBox",
    props: {
        value: {
            type: Array,
        },
        label: {
            type: String,
            default: "Created Between"
        }
    },
    data() {
        return {
            docCreatedDateRangeMenu: false,
            docCreatedDateRange: this.value || [],
        }
    },
    computed: {
        docCreatedDateRangeText: {
            get() {
                const range = this.docCreatedDateRange;
                if (!range || !range.length) return "";
                if (range.length == 1) return moment(range[0]).format("DD MMM YYYY");

                return range
                    .map((d) => {
                        return moment(d).format("DD MMM");
                    })
                    .join(" - ");
            },
            set(newValue) {
                const range = newValue
                    .split("-")
                    .map((x) => x.trim())
                    .filter((x) => x);
                if (range.length > 0 && range[0].length >= 8)
                    this.docCreatedDateRange[0] = moment(range[0], "DD MMM YYYY").format(
                        "YYYY-MM-DD"
                    );
                else if (range.length > 0 && range[0].length >= 4)
                    this.docCreatedDateRange[0] = moment(range[0], "DD MMM").format(
                        "YYYY-MM-DD"
                    );
                else this.docCreatedDateRange.splice(0);

                if (range.length > 1 && range[1].length >= 8)
                    this.docCreatedDateRange[1] = moment(range[1], "DD MMM YYYY").format(
                        "YYYY-MM-DD"
                    );
                if (range.length > 1 && range[1].length >= 4)
                    this.docCreatedDateRange[1] = moment(range[1], "DD MMM").format(
                        "YYYY-MM-DD"
                    );
                else if (this.docCreatedDateRange.length !== 0)
                    this.docCreatedDateRange[1] = moment().format("YYYY-MM-DD");

                this.$emit('input', this.docCreatedDateRange);
                this.$emit('change', this.docCreatedDateRange);
            },
        },
    },
    watch: {
        value(newVal) {
            this.docCreatedDateRange = newVal;
        },
    },
    methods: {
        doDateFilter() {
            const menu = Array.isArray(this.$refs.menu) ? this.$refs.menu[0] : this.$refs.menu;
            if (menu) menu.save(this.docCreatedDateRange);
            this.$emit('input', this.docCreatedDateRange);
            this.$emit('change', this.docCreatedDateRange);
        },
        clearDateFilter() {
            this.docCreatedDateRange.splice(0);
            this.docCreatedDateRangeMenu = false;
            this.$emit('input', this.docCreatedDateRange);
            this.$emit('change', this.docCreatedDateRange);
        },
    },
    created() { },
    mounted() { },
}
</script>